import { useDispatch, useSelector } from "react-redux";
import { organizationActions, work_spaceActions } from "../actions";
import { useCallback, useState } from "react";

function useDeleteWorkspacePopupHook() {
    const dispatch = useDispatch();
    const { selected_organization } = useSelector(state => state.sidebar);
    const [deleteWorkspacePopup, setDeleteWorkspacePopup] = useState({
        show: false,
        id: null,
    });
    const handleShowDeleteWorkspacePopup = (id) => setDeleteWorkspacePopup({ show: true, id });
    const handleCloseDeleteWorkspaceForm = () =>{
        setDeleteWorkspacePopup({ show: false, id: null });
    }


    const handleDeleteWorkspace = useCallback(() => {
        dispatch(work_spaceActions.destroyWorkSpace(deleteWorkspacePopup.id));
        dispatch(organizationActions.getWorkspaces(selected_organization));
        handleCloseDeleteWorkspaceForm();
    }, [
        dispatch, 
        deleteWorkspacePopup?.id, 
        selected_organization, 
        handleCloseDeleteWorkspaceForm
    ]);

    return {
        deleteWorkspacePopup,
        handleShowDeleteWorkspacePopup,
        handleCloseDeleteWorkspaceForm,
        handleDeleteWorkspace
    };
}

export default useDeleteWorkspacePopupHook;